<div class="container">
  <mat-form-field appearance="outline">
    <mat-label>Search an icon</mat-label>
    <input matInput [(ngModel)]="query">
  </mat-form-field>
  <div class="icons-container">
    <span *ngFor="let icon of icons"
          (click)="selectedIcon = 'fa-' + icon"
          [ngClass]="{ selected: selectedIcon === 'fa-' + icon }">
      <mat-icon fontSet="fa" fontIcon="{{ 'fa-' + icon }}">
      </mat-icon>
    </span>
  </div>
</div>
